module.exports = __webpack_public_path__ + "img/logo.c89f9723.png";